<template>
    <div id="step1">
        <a-row>
            <a-row>
                <p @click="() => (isForm = !isForm)" style="font-size: 13px;font-weight: 800;margin-left: 16px;" class="sbxs mt4">Query Condition <a-icon :type="isForm ? 'caret-up': 'caret-down'" /></p>
                <a-form :form="form" v-show="isForm"  style="margin-right: 4px;">
                    <a-row>
                        <a-col :span="8">
                            <a-form-item label="Wine Name" v-bind="formItemLayout">
                                <a-input
                                    autocomplete="off"
                                    style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['wineName']"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Year" v-bind="formItemLayout">
                                <a-input
                                        autocomplete="off"
                                        style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseEnter')"
                                        v-decorator="['year']"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Condition" v-bind="formItemLayout">
                                <a-select
                                        @change="remarkChangeAjax"
                                    style="width: 100%;" allowClear  size="small" :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="['itemRemark']">
                                    <a-select-option v-for="item in stepSelectData.itemRemarkData" :value="item.code">{{item.codeDesc}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Volume" v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"  :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['itemSize']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Bottle/Pack" v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"  :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['btperpkg']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Origin" v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"  :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['region']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Receive Date" v-bind="formItemLayout">
                                <a-date-picker  size="small" style="width: 100%;" v-decorator="['dateFm']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="To" v-bind="formItemLayout">
                                <a-date-picker size="small" style="width: 100%;" v-decorator="['dateTo']"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="Wine Type" v-bind="formItemLayout">
                                <a-input autocomplete="off" style="width: 100%;" size="small"  :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['wineType']"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <a-row type="flex" justify="end" class="mtb8">
                    <a-col>
                        <a-button type="danger" size="small" @click="clearFrom">Clear</a-button>
                    </a-col>
                    <a-col class="ml4">
                        <a-button type="primary" size="small" @click="searchTable" style="margin-right: 4px;">
                            <img src="../../../../assets/img/Liqutor-search.png" width="13" height="12" class="mr4"/>Search
                        </a-button>
                    </a-col>
                </a-row>
            </a-row>
            <a-spin :spinning="spinning">
                <a-row>
                    <a-row type="flex" justify="space-between" class="paddingLeftRight" style="font-weight: 800;color: #ababab;font-size: 14px;margin-left: 27px;">
                        <a-col>Inventory</a-col>
                        <a-col>
                            <a-row type="flex" justify="start">
                                <a-col>
                                    Total: {{tableList[0]!= null ? tableList[0].totalRecords : 0}} records
                                </a-col>
                                <a-col>

                                    <a-icon type="left" :style="{ cursor: pageNum == 1 ? 'not-allowed': 'pointer'}"  @click="pageInit('l')" />

                                    <a-input size="small" v-model="pageNum" style="width: 33px;text-align: center;font-size: 12px;margin: 0 4px" @pressEnter="pressEnter"/>

                                    <a-icon type="right" class="sbxs" @click="pageInit('r')" :style="{ cursor: pageNum == totalFeshu ? 'not-allowed': 'pointer'}" />
                                    <a-dropdown placement="bottomCenter" @click="pageSizeChange">
                                        <a-button size="small">{{pageSize}} / Page <a-icon type="down" style="font-size: 12px;"/></a-button>
                                        <a-menu slot="overlay"  @click="pageSizeChange">
                                            <a-menu-item key="10">10 / Page</a-menu-item>
                                            <a-menu-item key="20">20 / Page</a-menu-item>
                                            <a-menu-item key="30">30 / Page</a-menu-item>
                                            <a-menu-item key="40">40 / Page</a-menu-item>
                                            <a-menu-item key="100">100 / Page</a-menu-item>
                                            <a-menu-item key="500">500 / Page</a-menu-item>
                                            <a-menu-item key="1000">1000 / Page</a-menu-item>
                                        </a-menu>
                                    </a-dropdown>


                                    <a-badge :count="gouwucheData == null ? 0:gouwucheData == undefined ? 0: gouwucheData.length" class="mllr4">
                                        <img src="../../../../assets/img/gouwu2.png" width="23" height="23" class="sbxs" @click="gowuTotal">
                                    </a-badge>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                    <a-row style="height: 55vh;overflow-y: auto;" >
                        <a-row v-if="tableList.length == 0" style="display: flex;justify-content: center;align-items: center;height: 100%;">
                            <a-empty />
                        </a-row>
                        <a-row v-else type="flex" class="list_Liquor" v-for="(item,index) in tableList">
                            <a-col class="sbxs" @click="bigImgClick(item)">
                                <img v-if="item.photoBase != null" :src="item.photoBase" width="138" height="138">
                                <img  src="../../../../assets/img/nophoto.jpg"  width="138" height="138" v-else>
                            </a-col>
                            <a-col class="list_Liquor_detail">
                                <a-row type="flex" justify="space-between">
                                    <a-col class="list_Liquor_left">
                                        <a-col class='list_Liquor_title'>{{item.wineName == '' ? '.....' : item.wineName}}</a-col>
                                        <a-col style="height: 33px">{{item.remark}}</a-col>
                                        <a-row type="flex" justify="start" style="color: #707070;font-size: 12px;height: 20px;">
                                            <a-col>{{item.year}}</a-col>
                                            <a-col class="ml4">{{item.itemSize}}</a-col>
                                            <a-col class="ml4">{{item.region}}</a-col>
                                        </a-row>
                                        <a-col style="color: #707070;font-size: 12px;margin-top: 4px">Package: {{item.packageQty}}</a-col>
                                        <a-col style="color: #707070;font-size: 12px;">Received On: {{ item.receiveDate }}</a-col>
                                    </a-col>
                                    <a-col class="list_Liquor_Right">
                                        <a-col class="list_Liquor_Right_T">
                                            <a-col style="font-size: 12px;">
                                                <a-row type="flex" justify="start">
                                                    <a-col style="width: 180px; margin: 0 2px;"/>
                                                    <a-col style="width: 90px; text-align: rigth;" class=" list_Liquor_Right_Lebal">Available</a-col>
                                                    <a-col style="margin: 0 2px; text-align: left;">/</a-col>
                                                    <a-col style="width: 90px; text-align: left;"  class=" list_Liquor_Right_Lebal">On Hand</a-col>
                                                     <a-col style="text-align: left; margin-left: 3px"  class=" list_Liquor_Right_Lebal">Order Qty</a-col>
                                                </a-row>
                                                   
                                            </a-col>
                                            <a-col style="font-size: 26px;line-height: 24px" v-for="(detail,index2) in item.details">
                                                <!-- normal -->
                                                <a-row type="flex" justify="start" style="line-height: 35px;">
                                                    <a-col :title="detail.dudf04" class="list_Liquor_Right_Lebal list_Liquor_Right_Lebal_L" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" >{{detail.dudf04 == '' ? 'Normal': detail.dudf04}}</a-col>
                                                    <a-col style="text-align: rigth; width: 90px;">{{ parseInt(detail.avBaseQty)}}</a-col> 
                                                    <a-col style="margin: 0 2px"> / </a-col>
                                                    <a-col style="text-align: left; width: 90px;" >{{parseInt(detail.onHandBaseQty)}}</a-col>

                                             <a-dropdown size="small" v-if="detail.orderQtyFlag" style="text-align: left; margin: 6px 3px 0px 3px" >
                                                <a-menu size="small" slot="overlay" @click="OrderQtyClick($event,detail,index)">
                                                    <a-menu-item :key="tt" v-for="tt in 9" :disabled="tt > detail.avBaseQty">{{tt}}</a-menu-item>
                                                    <a-menu-item key="10" style="border:1px solid #efefef" :disabled="10 > detail.avBaseQty ">10+</a-menu-item>
                                                </a-menu>
                                                <a-button size="small" style="width: 60px;"> {{detail.orderQty =='' ? 1 : detail.orderQty}} <a-icon style="margin-left: 15px;" type="down" /> </a-button>
                                            </a-dropdown>
                                            <a-input-number
                                                    :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]/g, '')"
                                                    :parser="value => value.replace(/^(0+)|[^\d]/g, '')"
                                                    ref="orderQtyinputNumberRefs" :min="1"  size="small" v-else  style="width: 60px;" v-model="detail.orderQty" />

                                            <img style="margin-top: 6px" src="../../../../assets/img/gouwu1.png" width="24" height="24" class="sbxs mllr4"  @click="itemGoshopDetail(item,detail)">
                                                </a-row>
  
                                            </a-col>
                                        </a-col>
                                        <a-col>

                                            


                                        </a-col>
                                    </a-col>
                                </a-row>
                            </a-col>
                        </a-row>
                    </a-row>
                </a-row>
            </a-spin>
            <div style="height: 45px;"></div>
        </a-row>
        <div
            :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              zIndex: 1}">
            <a-button  class="fl" type="primary" size="small" style="visibility: hidden"><img src="../../../../assets/img/Liqutor-left.png" width="13" height="12" class="mr4">Previous</a-button>
            <a-button @click='goTypeClick("Next")' class="fr" type="primary" size="small"><img src="../../../../assets/img/Liqutor-arrow-right.png" width="13" height="12" class="mr4">Next</a-button>
            <div style="text-align: center">
                <a-button style="visibility: hidden" type="primary" size="small" @click="stepSave"><img src="../../../../assets/img/Liqutor-save.png" width="13" height="12" class="mr4">Save</a-button>
                <a-button v-if="false" @click="resetStep" style='margin-left: 40px;' type="danger" size="small"><img src="../../../../assets/img/Liqutor-refresh.png" width="13" height="12" class="mr4">Reset</a-button>
            </div>

        </div>

        <a-modal
                :title="targetImgBig.wineName"
                :visible="bigImgvis"
                :footer="null"
                width="950px"
                @cancel="() => (bigImgvis = !bigImgvis)"
        >
            <a-row type="flex" justify="start">
                <a-col style="height: 310px;overflow: auto;">
                    <a-row v-for="item in targetImgBig.pictureList">
                        <a-row class="mt4 sbxs">
                            <img v-if="item.photoBase != null" :src="item.photoBase" width="118" height="118" @click="leftPhotoXiao(item)">
                            <img src="../../../../assets/img/nophoto.jpg" width="118" height="118" v-else >
                        </a-row>
                        <a-row style="width: 94px;height: 1px;background-color: #707070;margin: 12px 0"></a-row>
                    </a-row>
                </a-col>
                <a-col style="margin-left: 4px;">
                    <img v-if="rightBigImg != null" :src="rightBigImg" width="385" height="310">
                    <img src="../../../../assets/img/nophoto.jpg" width="385" height="310"  v-else >
                </a-col>
                <a-row type="flex" justify="start" v-for="(skuItem,index) in skuInv">
                    <a-col style="margin-left: 4px;">
                        <div style="border: 1px #DEDEDE  solid;border-radius: 5px;">

                            <a-row style="height: 232px;width: 200px;">
                                <a-row >
                                    <a-col style="float: left;margin: 2px 2px;">
                                        <img src="../../../../../public/android/img/Img/NoPath - Copy (6).png" width="20" height="20" >
                                    </a-col>
                                    <a-col style="margin: 0 25px;color: #8C8C8C;font-size: 20px;">Stock On Hand</a-col>
                                </a-row>

                                <a-col style="margin-top: 30px ;margin-left: 40px; color: #2BA1CD ;font-size: 60px;">{{skuItem.soh}}</a-col>
                            </a-row>
                        </div>
                        <div style="margin-top: 4px;border: 1px #DEDEDE  solid;border-radius: 5px;height: 75px;width: 200px;">
                                <a-row >
                                    <a-col style="float: left;margin: 2px 2px;">
                                        <img src="../../../../../public/android/img/Img/NoPath - Copy (2).png" width="20" height="20" >
                                    </a-col>
                                    <a-col style="margin: 0 25px;color: #8C8C8C;font-size: 20px;">Last Receipt</a-col>
                                </a-row>

                                <a-col style="color: #000000 ;font-size: 20px;text-align: center">{{skuItem.lastReceiptDate}}</a-col>
                        </div>
                    </a-col>
                    <a-col style="margin-left: 4px;">
                        <div style="border: 1px #DEDEDE  solid;border-radius: 5px;width: 200px;height: 75px">
                            <a-row >
                                <a-col style="float: left;margin: 2px 2px;">
                                    <img src="../../../../../public/android/img/Img/NoPath - Copy.png" width="20" height="20" >
                                </a-col>
                                <a-col style="margin: 0 25px;color: #8C8C8C;font-size: 20px;">Available</a-col>
                            </a-row>


                            <a-col style="margin-right: 20px;color: #8ADEA2 ;font-size: 30px;text-align: right">{{skuItem.avaQty}}</a-col>
                        </div>

                        <div style="margin-top: 4px;border: 1px #DEDEDE  solid;border-radius: 5px;;width: 200px;height: 75px">
                            <a-row >
                                <a-col style="float: left;margin: 2px 2px;">
                                    <img src="../../../../../public/android/img/Img/NoPath.png" width="20" height="20" >
                                </a-col>
                                <a-col style="margin: 0 25px;color: #8C8C8C;font-size: 20px;">On Order</a-col>
                            </a-row>

                            <a-col style="margin-right: 20px;color: #E67B4B ;font-size: 30px;text-align: right">{{skuItem.onOrderQty}}</a-col>
                        </div>

                        <div style="margin-top: 4px;border: 1px #DEDEDE  solid;border-radius: 5px;;width: 200px;height: 75px">
                            <a-row >
                                <a-col style="float: left;margin: 2px 2px;">
                                    <img src="../../../../../public/android/img/Img/NoPath - Copy (7).png" width="20" height="20" >
                                </a-col>
                                <a-col style="margin: 0 25px;color: #8C8C8C;font-size: 20px;">On Hold</a-col>
                            </a-row>

                            <a-col style="margin-right: 20px;color: #808080;font-size:  30px;text-align: right">{{skuItem.onHoldQty}}</a-col>
                        </div>

                        <div style="margin-top: 4px;border: 1px #DEDEDE  solid;border-radius: 5px;width: 200px;height: 75px">
                            <a-row >
                                <a-col style="float: left;margin: 2px 2px;">
                                    <img src="../../../../../public/android/img/Img/NoPath - Copy (3).png" width="20" height="20" >
                                </a-col>
                                <a-col style="margin: 0 25px;color: #8C8C8C;font-size: 20px;">Last Dispatch</a-col>
                            </a-row>

                            <a-col style="color: #000000 ;font-size: 20px;text-align: center">{{skuItem.sku}}</a-col>
                        </div>

                    </a-col>
                </a-row>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import moment from "moment";
    export default{
        props:{
            sellLiquor: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            stepSelectData: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            initCloseValue:{
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        data(){
            return{
                isForm: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                form: this.$form.createForm(this),
                tableList:[],
                targetImgBig: {},
                rightBigImg: null,

                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                bigImgvis: false,
                pageNum: 1,
                pageSize: 30,
                searchInfo: {},
                totalFeshu: 0,
                targetPageNum: 0,
                gouwucheData: [], //总的购物车的数据
                skuInv:[],
                spinning: false, // 搜索加下提示
            }
        },
        created(){
            let that = this
            document.onkeydown = function(e) {
                let key = window.event.keyCode;
                if (key == 13) {
                    that.searchTable()
                }
            }
        },
        watch:{
            initCloseValue(v){
                this.gouwucheData = v.invTempDetailList
                this.init()
            }
        },
        methods:{
//            下拉选择也去search
            remarkChangeAjax(val){

                this.searchInfo.itemRemark = val
                this.init()
            },
//            清除表单内容
            clearFrom(){
                this.form.resetFields();
                this.searchInfo = {}
                this.init()
            },
            gowuTotal(){
                this.$emit('goType','Next')
            },
            itemGoshopDetail(item,detail){
                let arr =  []
//                取消全部提交
//                for(let i in this.tableList){
//                    if(this.tableList[i].orderQty > 0){
//                        let obj = {
//                            "itemSize":this.tableList[i].itemSize,
//                            "orderQty": this.tableList[i].orderQty,
//                            "packageQty": this.tableList[i].packageQty == '' ? 0 : item.packageQty,
//                            "region": this.tableList[i].region,
//                            "sku": this.tableList[i].sku,
//                            "wineName": this.tableList[i].wineName,
//                            "year": this.tableList[i].year,
//                            "skuCode": this.tableList[i].skuCode,
//                            "receivedTime": moment(this.tableList[i].receiveDate).format("YYYYMMDD")
//                        }
//                        arr.push(obj)
//                    }
//                }

                if(detail.avBaseQty == 0  || (parseInt(detail.orderQty)  - parseInt(detail.avBaseQty) > 0) ){
                    this.$message.warning('Input Qty is more than Available Qty!');
                    return
                }
                let obj = {
                            "itemSize":item.itemSize,
                            "orderQty": detail.orderQty,
                            "packageQty": item.packageQty == '' ? 0 : item.packageQty,
                            "region": item.region,
                            "sku": item.sku,
                            "wineName": item.wineName,
                            "year": item.year,
                            "skuCode":item.skuCode,
                            "receivedTime": moment(item.receiveDate).format("YYYYMMDD"),
                            "attr":detail.dudf04
                        }
                arr.push(obj)
                if(arr.length > 0){
                    let params = {
                        soDetail: arr,
                        currentStep: '1'
                    }
                      this.$store.commit("updataLoading", { pbLoading: true });
                    ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                        this.$store.commit("updataLoading", { pbLoading: false });
                        if(res.code == 200){
                            detail.avBaseQty = parseInt(detail.avBaseQty) -  parseInt(detail.orderQty)
                            ajax.post(api.INVWINEFINDTEMPSOORDERINFO).then(res=>{
                                if(res.data.invTempDetailList != null){
                                    this.gouwucheData  = res.data.invTempDetailList
                                }else{
                                    this.gouwucheData = []
                                }
                            })
                            this.$message.success(res.msg);
                            for(let i in this.tableList){
                                this.tableList[i].orderQty = 1
                            }
                        }else{
                            this.$message.warning(res.msg);
                        }
                    })
                }else{
                    this.$message.warning(this.$t('wine.AvailableQty'));
                }
            },
            moment,
//            分页satrt
            pageInit(type){
                if(type == 'l'){
                    if(this.pageNum < 2){
                        this.pageNum = 1
                    }else{
                        this.pageNum =  parseInt(this.pageNum) - 1
                        this.init()
                    }
                }else{
                    if(this.pageNum < 1){
                        this.pageNum = 1
                    }else{

                        this.pageNum = parseInt(this.pageNum) + 1
                        if(this.pageNum > this.totalFeshu){
                            this.pageNum =  parseInt(this.pageNum) - 1
                            return
                        }
                        this.init()
                    }
                }
            },
            pressEnter(){
                if(parseInt(this.pageNum) > this.totalFeshu || parseInt(this.pageNum) < 0 || parseInt(this.pageNum) == 0){
                    this.pageNum = this.targetPageNum
                }else{
                    this.init()
                }
            },
            pageSizeChange(val){
                this.pageSize =parseInt(val.key)
                this.pageNum = 1
                this.init()
            },
//            分页end
//            删除
            resetStep(){
                let arr = []
                for(let i in this.tableList){
                    const obj = {
                        "itemSize": this.tableList[i].itemSize,
                        "orderQty": this.tableList[i].orderQty,
                        "packageQty": this.tableList[i].packageQty,
                        "region": this.tableList[i].region,
                        "sku": this.tableList[i].sku,
                        "wineName": this.tableList[i].wineName,
                        "year": this.tableList[i].year,
                        "skuCode": this.tableList[i].skuCode,
                        "receivedTime": moment(this.tableList[i].receiveDate).format("YYYYMMDD")
                    }
                    arr.push(obj)
                }
                let params ={
                    deleteFlag: 0,
                    soDetail: arr
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.tableList = []
                        this.searchTable()
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
//            save 取消咯
            stepSave(){
                let arr= []
                let cacheArr = []
                for(let i in this.tableList){
                    if(this.tableList[i].orderQty > 0) {
                        const obj = {
                            "itemSize": this.tableList[i].itemSize,
                            "orderQty": this.tableList[i].orderQty,
                            "packageQty": this.tableList[i].packageQty == '' ? 0 :this.tableList[i].packageQty,
                            "region": this.tableList[i].region,
                            "sku": this.tableList[i].sku,
                            "wineName": this.tableList[i].wineName,
                            "year": this.tableList[i].year,
                            "skuCode": this.tableList[i].skuCode
                        }
                        arr.push(obj)
                        cacheArr.push(this.tableList[i])
                    }
                }
                if(arr.length == 0){
                    this.$message.warning('Please select your order item(s)');
                    return
                }
                let params = {
                    soDetail: arr,
                    currentStep: '1'
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.$emit('emitValue',{type: 'step1', data: cacheArr})
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
//            order Qty change 事件
            OrderQtyClick(v,detail,index){
                if(v.key == 10){
                    detail.orderQtyFlag = false
                        this.$nextTick(()=>{
                        let input = this.$refs.orderQtyinputNumberRefs[this.$refs.orderQtyinputNumberRefs.length -1].$el.children[1].children[0];
                        input.focus()
                        input.select()
                    })
                }
                detail.orderQty = v.key
            },
//            放大图片
            bigImgClick(item){
                this.targetImgBig = item
                if(item.pictureList != null && item.pictureList!= undefined && item.pictureList.length > 0 ){
                    this.rightBigImg = item.pictureList[0].photo
                }else{
                    this.rightBigImg = item.photoBase
                }
                this.bigImgvis = true
                this.skuInv=[]
                let params = this.targetImgBig.skuCode;
                ajax.post(api.INVSKU,params).then(res=>{
                    if(res.code == 200){
                        this.skuInv=(res.data);
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
            leftPhotoXiao(item){
                this.rightBigImg = item.photo
            },
//            初始化数据
            init(){
                let params = {}
                params = this.searchInfo
                this.spinning  = true
                params.pageNum = this.pageNum
                params.pageSize = this.pageSize
                ajax.post(api.INVALLINFO,params).then(res=>{
                    this.targetPageNum = this.pageNum
                    this.spinning  = false
                    if(res.code == 200){
                        this.tableList = res.data
                        if(this.tableList.length > 0){
                           this.totalFeshu = Math.ceil(parseInt(this.tableList[0].totalRecords) / this.pageSize)

                            for(let i in this.tableList){
                                let details = this.tableList[i].details;
                                if( details.length > 0 ){
                                    for(let y in details){
                                        if( details[y].orderQty == ''){
                                             details[y].orderQty = 1
                                        }
                                        if(details[y].orderQty > 10){
                                            details[y].orderQtyFlag = false
                                          }else{
                                            details[y].orderQtyFlag = true
                                         }
                                    }
                                    
                                }
                                this.tableList[i].receiveDate = moment(this.tableList[i].receiveDate).format("YYYY-MM-DD");
                            }
                            
                        }
                    }
                })
            },
//            搜索
            searchTable(val){
                this.form.validateFields((err, values)=>{
                    for(let i in values){
                        if(!values[i]){
                            delete values[i]
                        }
                    }
                    this.searchInfo = values
                    if(this.searchInfo.dateFm){
                        this.searchInfo.dateFm = (this.searchInfo.dateFm).format("YYYYMMDD")
                    }
                    if(this.searchInfo.dateTo){
                        this.searchInfo.dateTo = (this.searchInfo.dateTo).format("YYYYMMDD")
                    }
//                    table api
                    this.init()
                })
            },
            goTypeClick(type){
                if(type == 'Next'){
                    if(this.gouwucheData != null && this.gouwucheData !=undefined && this.gouwucheData.length > 0){
                        this.$emit('emitValue',{type: 'step1', data: this.gouwucheData})
                        this.$emit('goType',type)
                    }else{
                        this.$message.warning('Please select your order item(s)');
                    }
                }
            }
        }
    }
</script>
<style lang="less">
    .pageDisable2{
        cursor: not-allowed;
    }
  
    #step1{
        .list_Liquor{
            border-bottom:1px solid #b8b8b8;
            padding:6px 4px 6px 0;
            .list_Liquor_detail{
                flex: 1;
                margin-left: 10px;
                margin-top:8px;
                .list_Liquor_left{
                    .list_Liquor_title{
                        color: #698bdc;
                        font-weight: 800;
                        font-size: 14px;
                        margin-bottom: 10px;
                        width: 530px;
                        word-wrap: normal;
                    }
                }
                .list_Liquor_Right{
                    color: #707070;
                    text-align: right;
                    .list_Liquor_Right_T{
                        margin-bottom: 32px;
                    }
                   .list_Liquor_Right_Lebal_L{
                        width: 180px;
                        text-align: rigth;
                    }
                     .list_Liquor_Right_Lebal {
                        font-size: 15px;
                        font-weight: bold;
                    }
                }
            }
        }
    }

</style>